import {
  SET_PERMISSIONS,
  SET_MODULES,
  CLEAR_PERMISSIONS,
  INITIALIZE_PERMISSIONS,
} from '../actions/permissionsAction';
import { STORAGE_KEYS } from '../../utils/constants';

const initialState = {
  permissions: [],
  modules: [],
  loading: false,
  error: null,
};

const permissionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PERMISSIONS:
      return {
        ...state,
        permissions: action.permissions,
      };
    case SET_MODULES:
      return {
        ...state,
        modules: action.modules,
      };
    case CLEAR_PERMISSIONS:
      return {
        ...initialState,
      };
    case INITIALIZE_PERMISSIONS:
      const storedPermissions = localStorage.getItem(STORAGE_KEYS.PERMISSIONS);
      if (storedPermissions) {
        return {
          ...state,
          permissions: JSON.parse(storedPermissions),
        };
      }
      return state;
    default:
      return state;
  }
};

export default permissionsReducer;

